module.exports = __webpack_public_path__ + "img/photo2.897b7fb5.jpeg";